import {styled} from '@mui/material/styles';
import MButton from '@mui/material/Button';
import MCard from '@mui/material/Card';
import MInput from '@mui/material/Input';

import CircularProgress from '@mui/material/CircularProgress';

export * from './Progress'
export * from './HiddenBlcok'
export * from './Dialog'


export const defaultTheme = {
    buttonRadius: 0,
    hrBackground: 'rgb(255 255 255 / 30%)',
    testLinear: [
        `background: linear-gradient(45deg, #fda8d3, rgb(253 227 131))`,
        `background: linear-gradient(45deg, rgb(253 221 140), rgb(250 191 71))`,
        `background: linear-gradient(45deg, rgb(130 181 251), rgb(80 77 203))`,
        `background: linear-gradient(75deg, rgb(151 69 252), rgb(255 26 157), rgb(255 175 0))`,
        'background: linear-gradient(120deg,#ff8a38,#ff5400,#ff8a38)'
    ],
    card: {
        shape: {
            // borderRadius: '.4rem',
            boxShadow: '0px 0px 32px #00000085',
            
        },
        custom: {
            a: {
                background: 'linear-gradient(45deg, rgb(5 255 238), rgb(88 255 11), rgb(255 237 58))',
                color: '#311b02',
            },
            b: {
                background: 'linear-gradient(75deg, rgb(146 58 255), rgb(255 26 157), rgb(255 175 0))',
                color: '#f6eff9',
            },
            c: {
                background: 'linear-gradient(75deg, rgb(146 58 255), rgb(255 26 157), rgb(255 175 0))',
                color: '#311b02',
            },
            d: {
                background: 'linear-gradient(15deg, rgb(23 24 30), rgb(26 32 32))',
                color: '#f1f2fa',
            },
            e: {
                background: 'linear-gradient(45deg, rgb(200 20 125), rgb(8 133 177))',
                // boxShadow: '0 0 10px #dcfc35',
                color: '#f8f7f7',
            },
            f: {
                background: 'transparent',
                border: '1px dashed #dcfc35',
                // boxShadow: '0 0 10px #dcfc35',
                color: '#1c1d20',
            },
            g: {
                background: 'linear-gradient(45deg, rgb(81 4 49), rgb(11 77 100))',     
                color: '#1c1d20',
            },
            h: {
                background: 'linear-gradient(45deg, rgb(81 62 4), rgb(126 33 33))',     
                color: '#1c1d20',
            },
            j: {
                // position: 'relative',    
                // color: '#1c1d20',
                // zIndex: 0,
                // // border: '1px solid transparent',
                // background: '#000', 
                // backgroundClip: 'padding-box',
                // // background: 'linear-gradient(135deg, #ff6ec4, #7873f5)',
                // '::before' : {
                //     content: '""',
                //     position: 'absolute',
                //     top: 0,
                //     right:  0,
                //     left:  0,
                //     bottom:  0,

                //     // background: '#000', 
                //     background: 'linear-gradient(135deg, #ff6ec4, #7873f5)',
                    
                //     borderRadius: 'inherit',
                //     zIndex: -1
                // }
                color: '#f6eff9',
                border: '1px solid transparent',
                backgroundClip: 'padding-box, border-box',
                backgroundOrigin: 'padding-box, border-box',
                backgroundImage: 'linear-gradient(45deg, #1f1f21, #090808), linear-gradient(90deg, rgb(146 58 255), rgb(255 46 140), rgb(255 175 0))'
            }
        }
        
    },
    fontSize: {
        small: 12,
        medium: 16,
        large: 20,
        larger: 24,
        max: 32,
    },
    fontColor: [
        '#fff', '#f8f7f7', '#a3a9b6','#464a52', '#fafbf8', '#ff0000'/* warming */,
    ],
    fail: {
        // background: '#ddd',
        color: '#f21919'
    },
    button: {
        disabled: {
            background: '#88899b',
            color: '#c0c0c0',
        },
        type: {
            a: {
                background: 'linear-gradient(45deg, #fef903, #ffa626)',
                color: '#311b02',
            },
            b: {
                background: 'linear-gradient(75deg, rgb(146 58 255), rgb(255 26 157), rgb(255 175 0))',
                color: '#f6eff9',
            },
            c: {
                background: 'linear-gradient(45deg, rgb(137 255 247), rgb(106 249 66))',
                color: '#311b02',
            },
            d: {
                background: 'linear-gradient(45deg, rgb(5 255 238), rgb(88 255 11), rgb(255 237 58))',
                color: '#311b02',
            },
            e: {
                background: '#24262f',
                color: '#f1f2fa',
            },
            f: {
                background: '#2d2f36',
                color: '#f1f2fa',
            },
            unActive: {
                background: '#88899b',
                color: '#bfbecc',
            }
        }
    },
    input: {
        block: {
            background: 'rgb(9 9 9 / 82%)',
            color: '#f1f2fa',
            padding: '.2rem 0.4rem',
            borderRadius: '.8rem',
        },
        input: {
            background: 'transparent',
            color: '#f1f2fa',
            fontSize: '1.1rem',
            padding: '0.2rem .2rem',
            width: '100%',
        },
        background: '#242625',
        color: '#f1f2fa',
    },
    dialog: {
        background: 'transparent',
    }
}
// button
export function Button({children, size="medium", loading = false, disabled = false, type='a', ...props}) {
    const buttonTheme = defaultTheme.button.type[type]
    return (
        <MButton
            sx={{
                ...buttonTheme,
                pointerEvents: loading ? 'none' : 'auto',
                '&:hover': {
                    background: buttonTheme.background
                },
                "&.Mui-disabled": {
                    ...buttonTheme,
                    opacity: 0.5,
                }
            }}
            size={size}
            disabled={disabled}
            {...props}
            startIcon={
                loading && <CircularProgress
                    size={defaultTheme.fontSize[size]}
                    sx={{
                        color: buttonTheme.color
                    }}
                    thickness={5}
                />
            }
        >
            {children}
        </MButton>
    )
}

// text
const Text = styled('span', {
    shouldForwardProp: prop => !['block', 'hidden', 'fail', 'color'].includes(prop),
})`
    ${p => p.block && 'display: block'};
    ${p => p.hidden && 'display: none'};
    color: ${p => {
        return defaultTheme.fontColor[p.color || 1]
    }};
    ${p => p.fail ? defaultTheme.fail : null};
`
export const TextS = styled(Text)`
    font-size: ${defaultTheme.fontSize.small}px;
`
export const TextM = styled(Text)`
    font-size: ${defaultTheme.fontSize.medium}px;
`
export const TextL = styled(Text)`
    font-size: ${defaultTheme.fontSize.large}px;
`
export const TextXL = styled(Text)`
    font-size: ${defaultTheme.fontSize.larger}px;
`
export const TextMax = styled(Text)`
    font-size: ${defaultTheme.fontSize.max}px;
`

export const TextLinear = styled('span')`
    ${props => defaultTheme.testLinear[props.linear || 0]};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`

// card
const defaultPadding = '0.6rem'
export const Card = styled(MCard)`
    ${p => {
        const padding = !p.spacing ?
            defaultPadding :
            typeof p.spacing === 'number' ?
            p.spacing + 'rem' :
            p.spacing instanceof Array ?
                p.spacing.map(v => v + 'rem').join(' ') :
                defaultPadding
        return {
            ...defaultTheme.card.shape,
            ...defaultTheme.card.custom[p.type || 'd'],
            padding
        }
    }};
`

// input
export function Input({before, after, input = {}, inputStyle={}, fullWidth=true, ...props}) {
    return (
        <InputBlock fullWidth={fullWidth} {...props}>
            {before}
            <MInput
                disableUnderline
                sx={defaultTheme.input.input}
                inputProps={{
                    style: {
                      padding: 0,
                      ...inputStyle
                    }
                }}
                {...input}
            />
            {after}
        </InputBlock>
    )
}
const InputBlock = styled('div')`
    ${p => {
        return {
            ...defaultTheme.input.block,
            width: p.fullWidth ? '100%' : 'max-content'
        }
    }};
    display: flex;
    align-items: center;
`

export const WhiteSpace = styled('div')`
    width: 100%;
    text-align: center;
    height: ${p => p.size || .8}rem;
`

export const WhiteSpaceVertical  = styled('div')`
    position: relative;
    height: 100%;
    text-align: center;
    width: ${p => p.size || .4}rem;
`

// hr
export const Hr = styled('div')`
    width: ${props => props.w || 100}%;
    height: 1px;
    transform: scaleY(50%);
    background: ${ p => p.color || defaultTheme.hrBackground };
    ${p => p.padding ? `padding: ${p.padding[0] || 0}rem ${p.padding[1] || 0}rem`:''};
`
export function Fragment({children}) {
    return <>{children}</>
}

export const Tips = styled('span')`
    font-size: 12px;
    /* margin-top: 0.2rem; */
    ${p => defaultTheme.card.custom[p.type || 'a']}
    padding: 0.05rem .2rem;
    border-radius: .2rem;
`

export const FlexBLock = styled('div')`
    display: flex;
    justify-content: ${p => p.justify || 'space-between'};
    align-items: ${p => p.align || 'center'};
    ${p => {
        const padding = !p.spacing ?
            0 :
            typeof p.spacing === 'number' ?
            p.spacing + 'rem' :
            p.spacing instanceof Array ?
                p.spacing.map(v => v + 'rem').join(' ') :
                0
        return {
            padding
        }
    }};
`
// countdown
// export function Countdown({time, ...props}) {
//     const [count, setCount] = useState(time)
//     useEffect(() => {
//         if (count > 0) {
//             setTimeout(() => {
//                 setCount(count - 1)
//             }, 1000);
//         }
//     }, [count])
//     return (
//         <TextM {...props}>{count}</TextM>
//     )
// }


// loading
export function LoadingBlock({loading = false, children, style}) {
    return (
        loading ? 
        <div style={{textAlign: 'center', ...style}}>
            <CircularProgress color="inherit"/>
        </div> :
        children.length === 0 ?
        <div style={{padding:'8px 0px', textAlign:'center'}}>
            <img style={{width: '38px'}} src='./icon/notdata1.png' />
        </div> : 
        children
    )
}
